<template>
  <div class="card-style">
    <template v-for="(item, index) in cardList">
      <el-radio-group
        :key="index"
        v-model="cardStyle"
        @change="handleOnRadioChange"
      >
        <img
          :class="['card-style-item', index + 1 === cardStyle ? 'card-style-item__active' : '']"
          :src="item.src"
          fit="cover"
        />
        <el-radio
          class="card-style-item__radio"
          :label="item.cardStyle"
        >
          {{ item.name }}
        </el-radio>
      </el-radio-group>
    </template>
  </div>
</template>

<script>
import cardList from './images'
export default {
  name: 'CardStyle',
  props: {
    data: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      cardList,
      cardStyle: this.data
    }
  },
  watch: {
    data () {
      // 若后端返回为 0 则默认设置为 1
      this.cardStyle = this.data === 0 ? 1 : this.data
    }
  },
  methods: {
    handleOnRadioChange () {
      this.$emit('on-radio-change', this.cardStyle)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-style {
  display: flex;
  height: 150px;
  margin: 10px 30px 20px 30px;

  .card-style-item {
    margin-right: 30px;
    width: 194px;
    height: 110px;
    background-color: #f5f5f5;
    border: 1px solid #f0f0f0;

    /deep/.el-image__inner {
      width: 194px;
      height: 112px;
    }
  }

  .card-style-item__active {
    border: 1px solid #009cff;
  }

  .card-style-item__radio {
    margin-top: 22px;
    padding-left: 5px;
    width: 194px;
    text-align: left;
  }
}
</style>
